import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { useSetting } from '../context/SettingContext';

const Layout = ({ children }) => {
    const { t } = useTranslation();
    const { setting } = useSetting();
    const [isSidebarVisible, setSidebarVisible] = useState(window.innerWidth >= 1024);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    
    const toggleSidebar = () => {
        setSidebarVisible(!isSidebarVisible);
    };
    
    const handleResize = () => {
        const isNowMobile = window.innerWidth < 1024;
        setIsMobile(isNowMobile);
        
        if (isNowMobile) {
            setSidebarVisible(false);
        } else {
            setSidebarVisible(true);
        };
    };
    
    useEffect(() => {
        // Set the page title
        document.title = setting[`title_${t('languages.select')}`];
        
        // Resize listener
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [setting, t]);
    
    return (
        <div className='flex flex-col min-h-screen'>
            {/* Sidebar */}
            <div
                className={`
                    fixed z-40 transform transition-transform duration-300
                    ${isSidebarVisible ? 'translate-x-0' : '-translate-x-full'}
                `}
            >
                <Sidebar t={t} />
            </div>
            
            {/* Backdrop */}
            {isSidebarVisible && isMobile && (
                <div
                    className='fixed inset-0 z-20 bg-black bg-opacity-50 backdrop-blur-sm'
                    onClick={toggleSidebar}
                />
            )}
            
            {/* Navbar */}
            <Navbar toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
            
            {/* Main Content */}
            <div
                className={`
                    flex flex-grow transition-all duration-300
                    ${isSidebarVisible && !isMobile ? 'ml-64' : 'ml-0'}
                `}
            >
                <div className='flex-grow px-5 pt-20 pb-5 bg-antiFlashWhite overflow-auto'>
                    {children}
                </div>
            </div>
            
            {/* Footer */}
            <Footer t={t} isSidebarVisible={isSidebarVisible} />
        </div>
    );
};

export default Layout;
